/* eslint no-unused-vars: [ "error", { "argsIgnorePattern": "_" } ] */

import Vue from 'vue';
import Vuex from 'vuex';

// Meteo
import Meteo from '@/meteo';

// API
import Table from '@/api/table';
import Prediction from '@/api/prediction';

// Utils
// import Config from '@/config';
import Utils from '@/utils';
import Parsers from '@/parsers';

Vue.use(Vuex);

function getDefaultState() {
  return {
    meteo: null,
    prediction: null, // {days: {data: 'YYYY-MM-DD[Z]', variables: {...}}, hours: {...}}
    headers: [],
    last: null,
    loading: 0,
    error: '',
    analisi_data: [],
    analisi_unit: '',
    data: [],
    data_unit: 'week',
  };
}

// initial state
const state = getDefaultState();

const getters = {};

const actions = {
  RESET_STATE({ commit }) {
      commit('RESET_STATE');
  },

  LOAD_TABLE({ commit }, range ) {
    let [start, end] = range || [null, null];
    commit('SET_LOADING', true);
    if (!start || !end)
      [start, end] = Utils.defaultDateRange();
    Table.list(start, end)
         .then(response => {
           commit('SET_LOADING', false);
           commit('SET_METEO', response.data);
         })
         .catch(err => {
           commit('SET_LOADING', false);
           commit('SET_ERROR', ''+err);
           console.warn(err);
         });
  },

  LOAD_HEADERS({ commit }) {
    commit('SET_LOADING', true);
    Table.headers()
         .then(response => {
           commit('SET_LOADING', false);
           commit('SET_HEADERS', response.data);
         })
         .catch(err => {
           commit('SET_LOADING', false);
           commit('SET_ERROR', ''+err);
           console.warn(err);
         });
  },

  LOAD_PREDICTION({ commit }) {
    commit('SET_LOADING', true);
    Prediction.list()
              .then(response => {
                commit('SET_LOADING', false);
                commit('SET_PREDICTION', response.data);
              })
              .catch(err => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', ''+err);
                console.warn(err);
              });
  },

  LOAD_LAST({ commit }) {
    commit('SET_LOADING', true);
    Table.last()
         .then(response => {
           commit('SET_LOADING', false);
           commit('SET_LAST', response.data);
         })
         .catch(err => {
           commit('SET_LOADING', false);
           commit('SET_ERROR', ''+err);
           console.warn(err);
         });
  },

  LOAD_ANALISI({ commit }, { unit, start, end }) {
    commit('SET_LOADING', true);
    Table.aggregate(unit, start, end)
         .then(response => {
           commit('SET_LOADING', false);
           commit('SET_ANALISI_UNIT', unit);
           commit('SET_ANALISI', response.data);
         })
         .catch(err => {
           commit('SET_LOADING', false);
           commit('SET_ERROR', ''+err);
           console.warn(err);
         });
  },

  LOAD_DATA({ commit }, { unit, start, end }) {
    commit('SET_LOADING', true);
    Table.aggregate(unit, start, end)
         .then(response => {
           commit('SET_LOADING', false);
           commit('SET_DATA_UNIT', unit);
           commit('SET_DATA', response.data);
         })
         .catch(err => {
           commit('SET_LOADING', false);
           commit('SET_ERROR', ''+err);
           console.warn(err);
         });
  },
};

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  SET_LOADING(state, value) {
    state.loading = state.loading + (value ? 1 : -1);
    if (state.loading < 0)
      state.loading = 0;
  },

  RESET_ERROR(state) {
    state.error = null;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },

  SET_METEO(state, data) {
    state.meteo = new Meteo.Meteo(Parsers.table_to_meteo(data));
  },

  SET_HEADERS(state, data) {
    state.headers = ([{'text': data.datetime, 'value': 'datetime'}]
      .concat(Object.entries(data)
                    .filter(([key, _]) => key != 'datetime')
                    .map(([key, value]) => ({'text': value, 'value': key}))));
  },

  SET_PREDICTION(state, data) {
    state.prediction = (data || {}) || {};
  },

  SET_ANALISI_UNIT(state, unit) {
    // TODO: Might be good idea to check here if unit is valid
    state.analisi_unit = unit;
  },

  SET_ANALISI(state, data) {
    state.analisi_data = Parsers.table_to_meteo(data);
  },

  SET_DATA_UNIT(state, unit) {
    // TODO: Might be good idea to check here if unit is valid
    state.data_unit = unit;
  },

  SET_DATA(state, data) {
    state.data = Parsers.table_to_meteo(data);
  },

  SET_LAST(state, data) {
    state.last = data || {};
  },
}

export default new Vuex.Store({
  modules: {},
  state,
  getters,
  actions,
  mutations,
})
